// extracted by mini-css-extract-plugin
export default {"drawerHeader":"DrawerHeader_drawerHeader__k4LH+","spacer":"DrawerHeader_spacer__AsNOC","title":"DrawerHeader_title__Xmg9q"};